import React from 'react';

import { Divider, Flex, useBreakpointValue } from '@chakra-ui/react';

import mentees from '@assets/mentees.svg';
import sessionsBooked from '@assets/sessionsBooked.svg';
import wallet from '@assets/wallet.svg';

import { MenterInfoCard } from '../cards/MenterInfoCard';

export const MentorIcon = () => {
    const isMobile = useBreakpointValue({ base: true, md: false });

    return (
        <Flex
            mt={{ base: 2, md: 20 }}
            mx={{ base: 0, md: -10, lg: -20 }}
            bg="headerBg"
            align="center"
            justifyContent="center"
            gap={12}
            p={16}
            direction={{ base: 'column', md: 'row' }}
        >
            <MenterInfoCard
                imageSrc={wallet}
                heading="80%"
                text="of learning happens outside formal education"
            />
            {!isMobile && <Divider orientation="vertical" height="60" />}
            <MenterInfoCard
                imageSrc={sessionsBooked}
                heading="67%"
                text="of businesses report improved productivity through mentorship"
            />
            {!isMobile && <Divider orientation="vertical" height="60" />}
            <MenterInfoCard
                imageSrc={mentees}
                heading="70%"
                text="of professionals with mentors feel more confident in their careers"
            />
        </Flex>
    );
};
